import { render, staticRenderFns } from "./MajorsList.vue?vue&type=template&id=1ef45e60&scoped=true"
import script from "./MajorsList.vue?vue&type=script&lang=js"
export * from "./MajorsList.vue?vue&type=script&lang=js"
import style0 from "./MajorsList.vue?vue&type=style&index=0&id=1ef45e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef45e60",
  null
  
)

export default component.exports